import { Box, Typography } from '@atgfr8/atg-ui-tailwind';
import { AccountIcon, EmailIcon, PencilIcon, PhoneIcon } from '@atgfr8/icons';
import SectionCard from '@mobileComponents/SectionCard';
import { customerDetailsStore } from '@mobileStore/customer';
import { formatPhoneNumber } from '@utils/phoneNumberFormat';
import { For, Show, createSignal } from 'solid-js';

import AddEditContact from './AddEditContact';

const ICON_COLOR = '#026ea1';

const Contacts = () => {
  const [selectedContactId, setSelectedContactId] = createSignal<
    number | undefined
  >(undefined);

  return (
    <Box>
      <SectionCard title="CONTACTS" endIcon={<AddEditContact />}>
        <For each={customerDetailsStore.customer.contacts}>
          {(item) => (
            <Box class="flex justify-between items-center gap-2 border-b p-2 w-full">
              <Box class="flex flex-col gap-1 min-w-0 flex-1">
                <Box class="flex items-center gap-2">
                  <AccountIcon size={16} color={ICON_COLOR} />
                  <Typography variant="subtitle1" class="text-[14px]!">
                    {item.name}
                  </Typography>
                </Box>

                <Show when={item.phone}>
                  <Box class="flex items-center gap-2">
                    <PhoneIcon size={16} color={ICON_COLOR} />
                    <a href={`tel:${item.phone}`} class="text-[#026ea1]">
                      {formatPhoneNumber(item.phone || '')}
                    </a>
                  </Box>
                </Show>

                <Show when={item.email}>
                  <Box class="flex items-center gap-2 min-w-0">
                    <span class="shrink-0">
                      <EmailIcon size={16} color={ICON_COLOR} />
                    </span>
                    <a
                      href={`mailto:${item.email}`}
                      class="text-[#026ea1] break-all min-w-0"
                    >
                      {item.email}
                    </a>
                  </Box>
                </Show>
              </Box>

              <Box class="flex flex-col items-end gap-1">
                <Typography variant="body2" class="text-[14px]!">
                  {item.type}
                </Typography>
                <PencilIcon
                  color={ICON_COLOR}
                  size={20}
                  onClick={() => setSelectedContactId(item.id)}
                />
              </Box>
            </Box>
          )}
        </For>
      </SectionCard>
      <Show when={selectedContactId()} keyed>
        {(contactId) => (
          <AddEditContact
            contactId={contactId}
            isOpen={true}
            onClose={() => setSelectedContactId(undefined)}
          />
        )}
      </Show>
    </Box>
  );
};

export default Contacts;
